// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-master .el-table th.customer-code,\n.user-master .el-table td.customer-code {\n  width: 9em !important;\n}", ""]);
// Exports
module.exports = exports;
